import { UploadPublicLink } from "@utils/PublicLinkUtils";
import { useContext, useState } from "react";
import { NotificationsContext } from "../ui-components/Notifications";
import useCountryAxiosInstance from "../hooks/useCountryAxiosInstance";
import {
  ArrowDownTrayIcon,
  ClipboardDocumentListIcon,
  PencilIcon
} from "@heroicons/react/24/solid";
import Button from "../ui-components/Button";


const ExplorerPublicLink = ({
    row, _rows, intl, lookup, setData
}) => {

        const { push } = useContext(NotificationsContext);
        const apiRequest = useCountryAxiosInstance();
        const [loading, setLoading] = useState(false);

        return(
          <div className="flex flex-row gap-x-3">
            <a target="_blank" rel="noreferrer" href={row.link}>
              <Button className="text-xxs">
                <ArrowDownTrayIcon
                  className="-ml-0.5 mr-1 h-4 w-4"
                  aria-hidden="true"
                />
                Download
              </Button>
            </a>
            <Button
              styleType="empty"
              className="text-xxs"
              onClick={() => navigator.clipboard.writeText(row.link)}
            >
              <ClipboardDocumentListIcon
                className="-ml-0.5 mr-1 h-4 w-4"
                aria-hidden="true"
              />
              Copy Link
            </Button>
            <Button
              className="text-xxs"
              submitting={loading}
              onClick={
                async()=> {
                  await UploadPublicLink(row, push, apiRequest, true, setData, setLoading)
                }
              }
            >
              <PencilIcon
                className="-ml-0.5 mr-1 h-4 w-4"
                aria-hidden="true"
              />
              Edit
            </Button>
          </div>
        )
}

export default ExplorerPublicLink;